import useSWRInfinite from 'swr/infinite';
import { getSearchResults, convertFiltersToQueryString } from '../lib/fetcher';

const SEARCH_API = process.env.NEXT_PUBLIC_SEARCH_API;

/**
 * @summary Use infinite search.
 * @param {object} props
 * @param {Array<any>} props.fallbackData Fallback data to use.
 * @param {{ page?: number, term?: string, count?: number, show?: { name?: string, value?: string }}} props.selection User's current selection.
 */
export const useInfiniteSearch = ({
	fallbackData = [], selection,
}) => {
	const getKey = (index) => {
		const filtersQS = convertFiltersToQueryString(selection.filters);
		// eslint-disable-next-line max-len
		const url = `${SEARCH_API}?term=${selection.term}&page=${index + 1}&count=${selection.count || 12}${filtersQS ? `&${filtersQS}` : ''}${selection.show.name ? `&${selection.show.name}=${selection.show.value}` : ''}&isUsTraffic=${selection.isUsTraffic}`;
		return url;
	};

	const {
		data, error, size, setSize, isValidating,
	} = useSWRInfinite(
		getKey,
		getSearchResults,
		{
			initialSize: selection.page,
			persistSize: true,
			fallbackData,
			revalidateOnFocus: false,
		},
	);

	const isLoading = (!data && !error) || (size > 0 && data && typeof data[size - 1] === 'undefined');

	const isEmpty = data && data[0]?.result?.length === 0;

	const results = data ? [].concat(...data.map((search) => search.result)) : [];

	const found = data[0] ? Number(data[0].found_posts) : 0;

	const isEnd = isEmpty || (data && data[data.length - 1]?.result?.length < selection.count) || found <= selection.count;

	return {
		error,
		found,
		isEnd,
		isLoading,
		isValidating,
		results,
		size,
		setSize,
	};
};
